import {View, Text, StyleSheet} from 'react-native';
import {theme} from 'config/themes';

import type {ReactNode, MouseEvent} from 'react';
import type {FileListItemProps} from 'interface/stacks/FileListItem';

export interface FileListItemCellProps extends FileListItemProps {
  renderIcons?: () => ReactNode,
  renderThumbnail: () => ReactNode,
  onDropDownMenu: (e: MouseEvent) => void,
}

export function FileListItemCell(props: FileListItemCellProps) {
  return (
    <View style={styles.root}>
      <View style={styles.thumbnail}>
        {props.renderThumbnail()}
      </View>
      <View style={styles.name}>
        <Text
          style={styles.title}
          ellipsizeMode="middle"
          lineBreakMode="middle"
          numberOfLines={2}>
          {props.item.name}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    width: '100%',
    overflow: 'hidden',
    padding: 6,
  },
  thumbnail: {
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  name: {
    marginTop: 8,
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 120,
    overflow: 'hidden',
  },
  title: {
    fontSize: 13,
    textAlign: 'center',
    color: theme.files.listItem.title,
    // wordBreak: 'break-word', TODO: WEB ONLY
  }
});
